<template>
  <div>
    <!-- pc -->
    <!-- <div v-if="isfill" class="bg_000000 hidden-xs hidden-sm hidden-md" style="height: 136px;"></div> -->
    <div v-if="isfill" class="bg_000000 hidden-lg" style="height: 78px;"></div>
    <div :class="is_zhankai ? 'bg_000000' : isfill ? 'bg_000000' : 'bg_lucency header_fixed'"
      class="header_group p_flex p_align_items p_justify_center hidden-xs hidden-sm hidden-md">
      <img @click="$router.replace('/')" class="header_logo p_hand"
        :src="require('@/assets/images/header/header_logo.png')" alt="wozhike" />
      <!-- pc nav -->
      <div class="header_title p_flex">
        <!-- 动态获取的导航 -->
        <div v-for="item in request_list" :key="item.productNameCn" class="header_title_item p_hand font_800">
          <div @click="goodsnav_click('pc',item.productId)" v-if="GET_LANG === 'zh'"
            :class="$route.params.id === item.productId ? 'color_DC000C' : 'color_ffffff'" class="title_item p_line1_dot">
            {{ item.productNameCn }}
          </div>
          <div @click="goodsnav_click('pc',item.productId)" v-if="GET_LANG === 'en'"
            :class="$route.params.id === item.productId ? 'color_DC000C' : 'color_ffffff'"
            class="title_item p_line1_dot color_ffffff">
            {{ item.productNameEn }}
          </div>
          <div @click="goodsnav_click('pc',item.productId)" v-if="GET_LANG === 'ja'"
            :class="$route.params.id === item.productId ? 'color_DC000C' : 'color_ffffff'"
            class="title_item p_line1_dot color_ffffff">
            {{ item.productNameJp }}
          </div>
        </div>
        <div style="height: 18px;border-left: 2px solid rgba(255,255,255,0.5);"></div>
        <!-- 固定的导航 -->
        <nav v-for="item in guding_list" @click="nav_click(item)" :key="item.title"
          class="header_title_item p_hand font_800">
          <div class="title_item color_ffffff" :href="item.link">{{ $t(item.title) }}</div>
        </nav>
      </div>
      <!-- user -->
      <div class="header_right p_flex p_align_items">
        <div @click="$router.push('/aboutUs')"
          class="header_addbtn p_hand p_text_center border_radius6 color_ffffff font_800">{{ $t('footer.aboutus') }}
        </div>
        <div v-if="!GET_TOKEN && GET_LANG !== 'zh'" @click="$router.push('/login')"
          class="header_nologin p_hand border_radius_round color_ffffff p_text_center">
          <!-- {{ $t('login.signin') }} -->
          <!-- Log in -->
        </div>
        <img @click="$router.push('/userCenter')" v-if="GET_TOKEN && GET_LANG !== 'zh'" :src="GET_USER.avatar"
          class="header_login p_hand border_radius_round" alt="" />
      </div>
      <!--  -->
    </div>
    <!-- h5 -->
    <div :class="is_zhankai ? 'bg_000000' : isfill ? 'bg_000000' : 'bg_lucency'"
      class="header_group_h5 header_fixed hidden-lg">
      <img @click="$router.replace('/')" class="header_logo_h5 p_hand"
        :src="require('@/assets/images/header/header_logo_h5.png')" alt="wozhike" />
      <!-- 隐藏展示的内容 -->
      <div :class="is_zhankai ? '' : 'hidden'" class="header_title_h5">
        <!-- 动态获取的导航 -->
        <div v-for="item in request_list" :key="item.productNameCn" class="header_title_item p_hand font_800">
          <div @click="goodsnav_click('h5',item.productId)" v-if="GET_LANG === 'zh'"
            class="font_15 color_ffffff p_text_center">{{ item.productNameCn }}</div>
          <div @click="goodsnav_click('h5',item.productId)" v-if="GET_LANG === 'en'"
            class="font_15 color_ffffff p_text_center">{{ item.productNameEn }}</div>
          <div @click="goodsnav_click('h5',item.productId)" v-if="GET_LANG === 'ja'"
            class="font_15 color_ffffff p_text_center">{{ item.productNameJp }}</div>
        </div>
        <div style="border-top: solid 1px rgba(255, 255, 255, .3);"></div>
        <!-- 固定的导航 -->
        <nav v-for="item in guding_list" @click="nav_click(item)" :key="item.title"
          class="header_title_item p_hand font_800">
          <div class="font_15 color_ffffff p_text_center">{{ $t(item.title) }}</div>
        </nav>
        <div style="border-top: solid 1px rgba(255, 255, 255, .3);"></div>
        <div class="header_title_item p_hand">
          <div @click="$router.push('/aboutUs?id=shequn')" class="font_15 color_ffffff p_text_center font_800">
            {{ $t('header.addshequn') }}
          </div>
        </div>
        <div style="padding-top: 30px;" v-if="GET_LANG !== 'zh'"
          :class="GET_TOKEN ? 'p_space_between' : 'p_justify_center'" class="p_flex">
          <div v-if="!GET_TOKEN" @click="$router.push('/login')"
            class="loginbtn_h5 color_ffffff font_15 font_bold p_text_center">{{ $t('login.signin') }}</div>
          <img v-if="GET_TOKEN" @click="$router.push('/userCenter')" :src="GET_USER.avatar"
            class="header_login border_radius_round p_hand" alt="" />
          <div v-if="GET_TOKEN" @click="signout_func" class="loginbtn_h5 color_ffffff font_15 font_bold p_text_center">
            {{ $t('login.signout') }}
          </div>
        </div>
      </div>
      <!--  -->
      <img v-show="!is_zhankai" @click="is_zhankai = !is_zhankai" class="header_caidan_h5 p_hand"
        :src="require('@/assets/images/header/header_zhedie_h5.png')" alt="wozhike" />
      <img v-show="is_zhankai" @click="is_zhankai = !is_zhankai" class="header_caidan_h5 p_hand"
        :src="require('@/assets/images/header/header_close_h5.png')" alt="wozhike" />
    </div>
    <!--  -->
    <!-- 中文网站下提示tk -->
    <!-- <transition name="el-fade-in-linear">
      <div v-if="GET_LANG === 'zh'" class="tk_group p_flex p_column p_justify_center p_align_items">
        <div class="tk_xiaochengxu p_flex p_column p_align_items bg_ffffff border_radius14">
          <img class="tk_xiaochengxu_img" src="@/assets/images/verify/xiaochengxu_code.png" alt="" />
          <span style="padding-top: 50px;" class="font_18 color_000000">微信扫码进入“正品核验”小程序</span>
        </div>
      </div>
    </transition> -->
  </div>
</template>

<script>
  import {
    mapGetters,
    mapMutations
  } from 'vuex';
  import {
    product_main_list
  } from '@/network/index.js';
  import {
    set_timeStorage,
    get_timeStorage,
    window_open
  } from '@/utils/utils.js';
  export default {
    props: {
      isfill: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        is_zhankai: false,
        request_list: [],
        guding_list: [{
            title: 'header.allproduct',
            link: '/products',
            isNewPage: false
          },
          {
            title: 'header.onproduct',
            link: '/peripherals',
            isNewPage: false
          },
          // {
          //   title: 'header.lineshop',
          //   link: 'https://shop65303082.taobao.com/',
          //   isNewPage: true
          // },
          {
            title: 'header.heyan',
            link: '/verify',
            isNewPage: false
          }
        ]
      };
    },
    created() {
      get_timeStorage('indexListTime', list => {
        if (list) {
          this.request_list = [...list];
        } else {
          this.get_product_list();
        }
      });
    },
    computed: {
      ...mapGetters('login', ['GET_USER', 'GET_TOKEN']),
      ...mapGetters('setting', ['GET_LANG'])
    },
    methods: {
      ...mapMutations('login', ['EXIT_LGOIN']),
      signout_func() {
        //退出登录的逻辑
        this.EXIT_LGOIN();
      },
      get_product_list() {
        product_main_list({
          productID: '',
          sellStatusID: '',
          productName: '',
          pageIndex: 1,
          pageSize: 3
        }).then(res => {
          if (res.code === '0') {
            this.request_list = [...res.data.list];
            set_timeStorage('indexListTime', 600000, res.data.list);
          }
        });
      },
      nav_click(obj) {
        if (!obj) {
          return;
        }
        if (obj.isNewPage) {
          window_open(obj.link);
        } else {
          this.$router.push(obj.link);
        }
      },
      goodsnav_click(type,productId){
        this.$router.replace({
          path:'/productInfo/'+productId
        })
        if(type==='h5'){
          this.is_zhankai=false
        }
      }
    }
  };
</script>

<style scoped="scoped">
  .header_fixed {
    position: fixed !important;
    top: 0;
    z-index: 990;
  }

  .header_group {
    position: relative;
    width: 100vw;
    box-sizing: border-box;
    height: 136px;
    padding: 0 60px 0 30px;
  }

  .header_logo {
    position: absolute;
    left: 30px;
    top: 50%;
    transform: translateY(-50%);
    width: 80px;
    height: 80px;
  }

  .header_title .header_title_item {
    padding: 0 30px;
  }

  .title_item {
    font-size: 15px;
   /* max-width: 100px; */
  }

  .header_right {
    position: absolute;
    right: 60px;
    top: 50%;
    transform: translateY(-50%);
  }

  .header_addbtn {
    box-sizing: border-box;
    font-size: 15px;
    min-width: 140px;
    padding: 0 10px;
    height: 42px;
    line-height: 40px;
    border: 1px solid rgba(255, 255, 255, 0.5);
  }

  .header_nologin {
    font-size: 12px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    background-image: url('https://wozhike-1306886396.cos.ap-nanjing.myqcloud.com/app/common/default_avatar.png');
    background-size: 100% 100%;
  }

  .header_nologin,
  .header_login {
    width: 46px;
    height: 46px;
    line-height: 46px;
    opacity: 1;
    margin-left: 35px;
  }

  .header_login {
    border: 1px solid #ffffff;
  }

  /* h5 */
  .header_group_h5 {
    width: 100vw;
    box-sizing: border-box;
    height: 78px;
    padding: 0 15px;
  }

  .header_logo_h5 {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    width: 28px;
    height: 48px;
  }

  .header_title_h5 {
    border-top: 2px solid rgba(255, 255, 255, 0.5);
    width: 100%;
    height: calc(100%);
    box-sizing: border-box;
    background: #000;
    position: fixed;
    left: 0;
    top: 78px;
    z-index: 9999;
    padding: 0 30px;
  }

  .header_title_h5 .header_title_item {
    margin: 30px 0;
  }

  .header_caidan_h5 {
    width: 48px;
    height: 48px;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }

  .loginbtn_h5 {
    box-sizing: border-box;
    min-width: 140px;
    height: 42px;
    line-height: 42px;
    padding: 0 5px;
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    border: 1px solid rgba(255, 255, 255, 0.5);
  }
</style>



// WEBPACK FOOTER //
// src/components/public-header/public-header.vue